// extracted by mini-css-extract-plugin
export default {"direction-header":"styles_direction-header__W1LkN"};